import { configureStore } from "@reduxjs/toolkit";
import orderedItemReducer from "./OrderedItemsSlice";

export default configureStore({
  reducer: {
    ordredItem: orderedItemReducer,
  },
});
